export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkTracks: "nav-link-tracks",
  linkEvents: "nav-link-events",
  linkCorporate: "nav-link-corporate",
  linkHow: "nav-link-how",
  linkPartners: "nav-link-partners",
  linkFaq: "nav-link-faq",
  ctaExplore: "nav-cta-explore",
  ctaHost: "nav-cta-host",
  mobileMenuBtn: "nav-mobile-menu-btn",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  primaryCta: "hero-primary-cta",
  secondaryCta: "hero-secondary-cta",
  featuredCard: "hero-featured-card",
};

export const TRACKS = {
  section: "tracks-section",
  card: (id) => `track-card-${id}`,
  cardCta: (id) => `track-card-cta-${id}`,
};

export const EVENTS = {
  section: "events-section",
  filterChip: (v) => `events-filter-${v}`,
  card: (id) => `event-card-${id}`,
  cardCta: (id) => `event-card-cta-${id}`,
};

export const CORPORATE = {
  section: "corporate-section",
  cta: "corporate-cta",
};

export const CIRCLE = {
  form: "circle-form",
  name: "circle-name",
  email: "circle-email",
  phone: "circle-phone",
  city: "circle-city",
  interest: (v) => `circle-interest-${v}`,
  format: (v) => `circle-format-${v}`,
  submit: "circle-submit",
  success: "circle-success",
  error: "circle-error",
};

export const ENQUIRY = {
  form: "enquiry-form",
  fullName: "enquiry-full-name",
  email: "enquiry-email",
  phone: "enquiry-phone",
  company: "enquiry-company",
  role: "enquiry-role",
  city: "enquiry-city",
  interest: "enquiry-interest",
  category: "enquiry-category",
  format: "enquiry-format",
  audienceSize: "enquiry-audience-size",
  message: "enquiry-message",
  consent: "enquiry-consent",
  submit: "enquiry-submit",
  success: "enquiry-success",
  error: "enquiry-error",
};

export const FAQ = {
  section: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const FOOTER = {
  section: "footer-section",
};

export const STICKY = {
  mobile: "mobile-sticky-cta",
};
